import { Helmet } from 'react-helmet-async';
import { CONFIG } from 'src/config-global';
import LibraryDishItemDiscussion from 'src/sections/home/library-dish-item-discussion';

// ----------------------------------------------------------------------

const metadata = { title: `Dish Discussion |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <LibraryDishItemDiscussion />
    </>
  );
}
